import React, { useEffect, useState } from 'react';
import { getMinistries } from '../services/api';
import './Ministries.css';

export default function Ministries() {
  const [ministries, setMinistries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getMinistries()
      .then(setMinistries)
      .catch(() => setError('Impossible de charger les ministères.'))
      .finally(() => setLoading(false));
  }, []);

  const ICONS = ['✝️', '🎵', '👩‍👧‍👦', '📚', '🌍', '🤝'];

  return (
    <div className="ministries-page">
      <div className="page-banner">
        <div className="container">
          <h1>Nos Ministères</h1>
          <p>Trouvez votre place dans le corps de Christ</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="ministries-intro">
            <p>
              Chaque membre de notre église est appartient à la famille de Dieu et a un rôle à
              jouer. Nos ministères sont des espaces de croissance, de service et de communion où
              vous pouvez développer vos dons et impacter des vies.
            </p>
          </div>

          {loading && <div className="spinner-wrap"><div className="spinner" /></div>}
          {error && <div className="state-box"><h3>Erreur</h3><p>{error}</p></div>}

          {!loading && !error && ministries.length === 0 && (
            <div className="state-box">
              <h3>Aucun ministère trouvé</h3>
              <p>Revenez bientôt!</p>
            </div>
          )}

          {!loading && !error && (
            <div className="ministries-grid">
              {ministries.map((m, i) => (
                <MinistryCard key={m.id} ministry={m} icon={ICONS[i % ICONS.length]} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Join CTA */}
      <section className="ministries-cta">
        <div className="container ministries-cta__inner">
          <h2>Prêt à vous impliquer?</h2>
          <p>
            Contactez-nous pour en savoir plus sur les ministères qui correspondent à vos dons et
            votre passion.
          </p>
          <a href="/contact" className="btn btn-primary">Nous contacter ›</a>
        </div>
      </section>
    </div>
  );
}

function MinistryCard({ ministry, icon }) {
  return (
    <article className="ministry-card card">
      <div className="ministry-card__img-wrap">
        {ministry.image_url ? (
          <img src={ministry.image_url} alt={ministry.name} className="ministry-card__img" />
        ) : (
          <div className="ministry-card__img-placeholder">{icon}</div>
        )}
        <div className="ministry-card__img-overlay" />
        <span className="ministry-card__icon-badge">{icon}</span>
      </div>
      <div className="ministry-card__body">
        <h3>{ministry.name}</h3>
        {ministry.leader && (
          <p className="ministry-card__leader">👤 Responsable: {ministry.leader}</p>
        )}
        {ministry.description && (
          <p className="ministry-card__desc">{ministry.description}</p>
        )}
        <div className="ministry-card__info">
          {ministry.meeting_time && (
            <p>🕐 {ministry.meeting_time}</p>
          )}
          {ministry.meeting_location && (
            <p>📍 {ministry.meeting_location}</p>
          )}
          {ministry.contact_email && (
            <p>
              ✉️{' '}
              <a href={`mailto:${ministry.contact_email}`}>{ministry.contact_email}</a>
            </p>
          )}
        </div>
      </div>
    </article>
  );
}
